import React from 'react';
import './loader.css';

// Portal-wide brand loader (gradient ring spinner) — drop-in replacement
// for the old bare "Loading..." text used across the Librarian pages.
const Loader = ({ label = 'Loading...', size, compact = false, className = '' }) => {
  const sizeClass = size === 'sm' ? 'lib-loader--sm' : size === 'lg' ? 'lib-loader--lg' : '';

  return (
    <div
      className={`lib-loader-block ${compact ? 'lib-loader-block--compact' : ''} ${className}`}
      role="status"
      aria-live="polite"
    >
      <span className={`lib-loader ${sizeClass}`} aria-hidden="true" />
      {label && <span className="lib-loader-label">{label}</span>}
    </div>
  );
};

export default Loader;
